import { cx } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { useEffect, useMemo } from 'react';
import { usePersuasionModal } from '../../common/context/PersuasionModalContext';
import { generateReadMore } from '../../common/utils/readMore';
import { generateModal } from '../../common/utils/modal';
import Product from '../../common/components/Product';
import { useConfirmationModal } from '../../common/context/ConfirmationModalContext';
import { getProduct } from '../utils/singleChoiceTransformer';
import SingleChoiceToggleBar from './SingleChoiceToggleBar';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const persuasionModalName = name => `${name}Persuasion`;
const confirmationModalName = name => `${name}Confirmation`;
const isDefined = value => typeof value !== 'undefined';
const SingleChoice = _ref => {
  let {
    additionalInformation,
    children,
    className,
    confirmation,
    confirmationContent,
    descriptionAdditionalContent,
    form,
    hasLogo,
    isNeutral,
    isSelectable,
    isSelected,
    notSelectedLabel,
    order,
    persuasion,
    persuasionContent,
    pricePerTravelerRaw,
    priceRaw,
    productId,
    productName,
    productPosition,
    rootElement,
    readMoreContent,
    selectionAdditionalContent,
    setTravelerIds,
    shouldShowImage,
    shouldShowMandatoryChoiceText,
    shouldShowPricePerBound,
    shouldShowPricePerTraveler,
    text,
    title,
    typename,
    upSell
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    isOpen,
    onConfirm,
    onDecline,
    setIsOpen,
    setOnConfirm,
    setOnDecline
  } = usePersuasionModal();
  const {
    isOpen: isConfirmationOpen,
    onConfirm: onConfirmationConfirm,
    onDecline: onConfirmationDecline,
    setIsOpen: setIsConfirmationOpen,
    setOnConfirm: setConfirmationOnConfirm,
    setOnDecline: setConfirmationOnDecline
  } = useConfirmationModal();
  const product = useMemo(() => getProduct(productId, order, typename), [productId, order, typename]);
  useEffect(() => {
    if (setTravelerIds) {
      setTravelerIds(product === null || product === void 0 ? void 0 : product.travelerIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);
  if (!product) {
    return null;
  }
  const {
    readMore,
    numberOfBounds,
    priceRaw: defaultPriceRaw,
    isProductHighlighted,
    shouldShowPricePerBound: defaultShouldShowPricePerBound,
    shouldShowPricePerTraveler: defaultShouldShowPricePerTraveler
  } = product;
  const labelNo = t('Product.SingleChoice.Label.No');
  const labelYes = t('Product.SingleChoice.Label.Yes');
  const defaultNotSelectedLabel = t('Products.Price.Label.Only');
  const highlightProductLabel = isProductHighlighted ? t('Products.Highlight.Label') : '';
  const shouldDisplayConfirmation = confirmation !== null && confirmation !== void 0 && confirmation.isEnabled && confirmationContent ? confirmation : {
    isEnabled: false
  };
  return /*#__PURE__*/_jsx(Product, {
    additionalInformation: additionalInformation,
    buttons: /*#__PURE__*/_jsx(SingleChoiceToggleBar, {
      confirmation: shouldDisplayConfirmation,
      form: form,
      isNeutral: isNeutral,
      isSelected: isSelected,
      labelNo: labelNo,
      labelYes: labelYes,
      persuasion: persuasion,
      priceRaw: priceRaw || defaultPriceRaw,
      productName: productName,
      productPosition: productPosition,
      rootElement: rootElement,
      setConfirmationIsOpen: setIsConfirmationOpen,
      setConfirmationOnConfirm: setConfirmationOnConfirm,
      setConfirmationOnDecline: setConfirmationOnDecline,
      setPersuasionIsOpen: setIsOpen,
      setPersuasionOnConfirm: setOnConfirm,
      setPersuasionOnDecline: setOnDecline,
      travelers: order.travelers
    }),
    className: cx('singleChoice', productName, className),
    confirmation: generateModal({
      ...confirmation
    }, confirmationContent, confirmationModalName(productName)),
    description: text,
    descriptionAdditionalContent: descriptionAdditionalContent,
    hasLogo: hasLogo,
    isConfirmationOpen: isConfirmationOpen,
    isPersuasionOpen: isOpen,
    isProductHighlighted: isProductHighlighted,
    isSelectable: isSelectable,
    isSelected: isSelected,
    notSelectedLabel: notSelectedLabel || defaultNotSelectedLabel,
    numberOfBounds: numberOfBounds,
    onConfirmationConfirm: onConfirmationConfirm,
    onConfirmationDecline: onConfirmationDecline,
    onPersuasionConfirm: onConfirm,
    onPersuasionDecline: onDecline,
    persuasion: generateModal({
      ...persuasion
    }, persuasionContent, persuasionModalName(productName)),
    pricePerTravelerRaw: pricePerTravelerRaw,
    priceRaw: priceRaw || defaultPriceRaw,
    productId: productId,
    productName: productName,
    readMore: generateReadMore(readMore, readMoreContent),
    selectionAdditionalContent: selectionAdditionalContent,
    shouldShowImage: shouldShowImage,
    shouldShowMandatoryChoiceText: shouldShowMandatoryChoiceText,
    shouldShowPricePerBound: isDefined(shouldShowPricePerBound) ? shouldShowPricePerBound : defaultShouldShowPricePerBound,
    shouldShowPricePerTraveler: isDefined(shouldShowPricePerTraveler) ? shouldShowPricePerTraveler : defaultShouldShowPricePerTraveler,
    title: title,
    upSell: upSell || highlightProductLabel,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
};
export default SingleChoice;
//# sourceMappingURL=SingleChoice.js.map